import * as react from "react";
import { MomentConfig, MomentLongDateFormat } from "../Interop/Moment.fs.js";
import { DownOutlined, SettingFilled, MenuFoldOutlined, MenuUnfoldOutlined, FileProtectOutlined, StarOutlined, RiseOutlined, PushpinOutlined, HighlightOutlined, NodeIndexOutlined, ShoppingOutlined, ControlOutlined, PartitionOutlined, SettingOutlined, CompassOutlined, DashboardOutlined, UnorderedListOutlined, SearchOutlined } from "../Interop/Antd/Icon.fs.js";
import { append as append_1, collect, ofArray, singleton, empty } from "../fable_modules/fable-library-js.4.18.0/List.js";
import { defaultOf, uncurry2, uncurry3, curry2, curry4, int32ToString, curry3 } from "../fable_modules/fable-library-js.4.18.0/Util.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.18.0/Seq.js";
import { createRootNavComponent, PageGroup_$ctor_Z104CF0BE, PageWithoutNavComponent_$ctor_1FEFDAB5, Page_$ctor_36DAE502 } from "../Navigation.fs.js";
import { Route, Switch, NavProps, Location, Link, RouteProps } from "../Interop/ReactRouter.fs.js";
import { DiagnosticsEnabled } from "../../src/FeatureFlags.js";
import { Record } from "../fable_modules/fable-library-js.4.18.0/Types.js";
import { record_type, string_type, lambda_type, class_type, unit_type } from "../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { Profile, User_$reflection } from "../Services/Auth/Auth.fs.js";
import ff_loop54_logo from "../../public/ff_loop54_logo.svg";
import react_ga from "react-ga";
import { GA_TRACKING_ID } from "../Interop/ReactGA/ReactGA.fs.js";
import { sendEvent, initialize } from "../Interop/StartDeliver/StartDeliver.fs.js";
import { Userpilot } from "userpilot";
import en_US from "antd/es/locale/en_US";
import de_DE from "antd/es/locale/de_DE";
import locales_1 from "../../public/locales/locales.json";
import i18next from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { initI18next } from "../Interop/I18n/I18n.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/Fable.React.FunctionComponent.fs.js";
import { value as value_8 } from "../fable_modules/fable-library-js.4.18.0/Option.js";
import { useLocalStorage } from "../Hooks/LocalStorage.fs.js";
import { ButtonProps, Button } from "../Interop/Antd/Misc.fs.js";
import Portal_1 from "../../src/Views/Portal.css";
import { Context as Context_2, switchLabel, ExperimentalFeaturesContext, useExperimentalFeatures } from "../Hooks/ExperimentalFeatures.fs.js";
import { useExperimentalFeaturesEnabled } from "../../src/FeatureFlags.js";
import { useHistory } from "react-router-dom";
import { split, printf, toText } from "../fable_modules/fable-library-js.4.18.0/String.js";
import { Props as Props_1, FeatureSwitch } from "../Components/Switch/FeatureSwitch.fs.js";
import { Context } from "../Services/Notifications/Notifications.fs.js";
import { useWithCurrentQueryParams } from "../Hooks/WithQueryParams.fs.js";
import { Context as Context_1, useQuerySelection } from "../Hooks/QuerySelection.fs.js";
import { useUserAccess } from "../Hooks/UserAccess.fs.js";
import { item, equalsWith, map } from "../fable_modules/fable-library-js.4.18.0/Array.js";
import { SelectProps, Select } from "../Components/Select/Select.fs.js";
import { ScopePartValueModule_isConcrete, CustomerValue_toPart, ScopePartValueModule_toPart, ScopePartValueModule_fromPart, ScopePartValueModule_toText, CustomerValue_toText } from "../Hooks/ScopeComponentUtils.fs.js";
import QuerySelection from "../../src/Hooks/QuerySelection.css";
import { QueryFilter } from "../Loop54.Portal.Api.Model/KpiQueryFilter.fs.js";
import moment from "moment";
import { DropdownProps, Dropdown } from "../Components/Dropdown/Dropdown.fs.js";
import { Item, ItemGroupProps, ItemGroup, Menu } from "../Interop/Antd/Menu.fs.js";
import { Content, SiderProps, Sider, Header, LayoutProps, Layout } from "../Interop/Antd/Layout.fs.js";
import { HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.18.0/MapUtil.js";
import { GravatarProps, TopNavGravatar } from "../Components/Gravatar/ReactGravatar.fs.js";
import { wrapList } from "../Components/ErrorBoundary.fs.js";
import { Context as Context_3 } from "../Services/Auth/User.fs.js";
import boomerangRealUserMonitoring from "../../src/Utils/boomerangRealUserMonitoring.js";
import { ConfigProviderProps, ConfigProvider } from "../Interop/Antd/ConfigProvider.fs.js";
import { Context as Context_4, useUserScopeInformation } from "../Hooks/UserScopeInformation.fs.js";

export const Fallback = react.createElement("div", {
    className: "suspense-loading-delay",
}, "Loading...");

export const defaultPage = "/search/overview";

export const signOutUri = "/auth/signout";

export const momentEnLocaleConfig = new MomentConfig(new MomentLongDateFormat("YYYY-MM-DD"));

export const KpiOverviewComponent = (() => {
    const elemType = react.lazy(() => import("./Kpi.Overview.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const KpiExploreComponent = (() => {
    const elemType = react.lazy(() => import("./Kpi.Explore.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const KpiInspectComponent = (() => {
    const elemType = react.lazy(() => import("./Kpi.Inspect.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const ConfigurationSynonymsController = (() => {
    const elemType = react.lazy(() => import("./Configuration/Synonyms.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const ConfigurationBoostBuryController = (() => {
    const elemType = react.lazy(() => import("./Configuration/BoostBury.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const ConfigurationRedirectsController = (() => {
    const elemType = react.lazy(() => import("./Configuration/Redirect.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const ConfigurationExperienceController = (() => {
    const elemType = react.lazy(() => import("./Configuration/Experience.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const ConfigurationExperienceRuleEditorController = (() => {
    const elemType = react.lazy(() => import("./Configuration/ExperienceRuleEditor.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

export const ConfigurationRecommendationsController = (() => {
    const elemType = react.lazy(() => import("./Configuration/Recommendations.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const ConfigurationPulseController = (() => {
    const elemType = react.lazy(() => import("./Configuration/Pulse.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const DiagnosticsController = (() => {
    const elemType = react.lazy(() => import("./Diagnostics.fs.js").then((m) => m.render).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: Fallback,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const searchIcon = SearchOutlined(empty(), empty());

const browseIcon = UnorderedListOutlined(empty(), empty());

const dashboardIcon = DashboardOutlined(empty(), empty());

const exploreIcon = CompassOutlined(empty(), empty());

const configurationIcon = SettingOutlined(empty(), empty());

const configurationSynonymsIcon = PartitionOutlined(empty(), empty());

const configurationBoostBuryIcon = ControlOutlined(empty(), empty());

const merchandisingIcon = ShoppingOutlined(empty(), empty());

const merchandisingRedirectsIcon = NodeIndexOutlined(empty(), empty());

const merchandisingExperienceIcon = HighlightOutlined(empty(), empty());

const merchandisingRecommendationIcon = PushpinOutlined(empty(), empty());

const merchandisingPulseIcon = RiseOutlined(empty(), empty());

const recommendationsKpiIcon = StarOutlined(empty(), empty());

const permittedParamsScopeOnly = ["customerId", "storefrontId", "languageCode", "split"];

function createControlViews(isExperimentalFeaturesEnabled, routesWithCurrentQueryParams, routesWithCurrentQueryParamsAndNarrowedScope, navComponentWithCurrentQueryParams, navComponentWithCurrentQueryParamsAndNarrowedScope, access, t) {
    const routeWithCurrentQueryParams = (route) => curry3(routesWithCurrentQueryParams)(empty())(singleton(route));
    const routeWithCurrentQueryParamsWithProps = (props) => ((route_1) => curry3(routesWithCurrentQueryParams)(props)(singleton(route_1)));
    const routeWithCurrentQueryParamsAndNarrowedScope = (route_2) => curry3(routesWithCurrentQueryParamsAndNarrowedScope)(empty())(singleton(route_2));
    const routeWithCurrentQueryParamsAndNarrowedScopeWithProps = (props_1) => ((route_3) => curry3(routesWithCurrentQueryParamsAndNarrowedScope)(props_1)(singleton(route_3)));
    const permittedScopeAndDates = ["customerId", "storefrontId", "languageCode", "split", "startDate", "endDate"];
    const permittedScopeDatesAndMatch = ["customerId", "storefrontId", "languageCode", "split", "startDate", "endDate", "matchQuery", "matchType"];
    const searchViews = toList(delay(() => append(singleton_1(Page_$ctor_36DAE502(routesWithCurrentQueryParams(empty(), ofArray(["/search/overview", "/search/dashboard"]), (_arg) => KpiOverviewComponent({
        navigationType: "search",
    })), navComponentWithCurrentQueryParams([t.t("Overview"), dashboardIcon], ["/search/overview", permittedScopeAndDates]))), delay(() => append(singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParams("/search/explore")((_arg_1) => KpiExploreComponent({
        navigationType: "search",
    })), navComponentWithCurrentQueryParams([t.t("Explore"), exploreIcon], ["/search/explore", permittedScopeDatesAndMatch]))), delay(() => append(singleton_1(PageWithoutNavComponent_$ctor_1FEFDAB5(routeWithCurrentQueryParams("/search/inspect")((_arg_2) => KpiInspectComponent({
        navigationType: "search",
    })))), delay(() => append((access.BoostBuryAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScope("/search/boostBury")((_arg_3) => ConfigurationBoostBuryController({
        navigationType: "search",
    })), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Boost & Bury"), configurationBoostBuryIcon], ["/search/boostBury", permittedParamsScopeOnly]))) : empty_1(), delay(() => ((access.SynonymsAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScope("/configuration/synonyms")((_arg_4) => ConfigurationSynonymsController()), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Synonyms"), configurationSynonymsIcon], ["/configuration/synonyms", permittedParamsScopeOnly]))) : empty_1())))))))))));
    const search = PageGroup_$ctor_Z104CF0BE("search", t.t("Search"), searchIcon, searchViews);
    const browseViews = toList(delay(() => append(singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParams("/navigation/overview")((_arg_5) => KpiOverviewComponent({
        navigationType: "getentitiesbyattribute",
    })), navComponentWithCurrentQueryParams([t.t("Overview"), dashboardIcon], ["/navigation/overview", permittedScopeAndDates]))), delay(() => append(singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParams("/navigation/explore")((_arg_6) => KpiExploreComponent({
        navigationType: "getentitiesbyattribute",
    })), navComponentWithCurrentQueryParams([t.t("Explore"), exploreIcon], ["/navigation/explore", permittedScopeDatesAndMatch]))), delay(() => append(singleton_1(PageWithoutNavComponent_$ctor_1FEFDAB5(routeWithCurrentQueryParams("/navigation/inspect")((_arg_7) => KpiInspectComponent({
        navigationType: "getentitiesbyattribute",
    })))), delay(() => ((access.BoostBuryAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScope("/navigation/boostBury")((_arg_8) => ConfigurationBoostBuryController({
        navigationType: "getentitiesbyattribute",
    })), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Boost & Bury"), configurationBoostBuryIcon], ["/navigation/boostBury", permittedParamsScopeOnly]))) : empty_1())))))))));
    const browse = PageGroup_$ctor_Z104CF0BE("navigation", t.t("Navigation"), browseIcon, browseViews);
    const recommendationsViews = toList(delay(() => append((access.RecommendationsKpiGreAccess ? true : isExperimentalFeaturesEnabled) ? append(singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsWithProps(singleton(new RouteProps(2, [true])))(`${"/recommendations"}/gre`)((_arg_9) => KpiOverviewComponent({
        navigationType: "getrelatedentities",
    })), navComponentWithCurrentQueryParams([t.t("Similar"), dashboardIcon], [`${"/recommendations"}/gre`, permittedScopeAndDates]))), delay(() => singleton_1(PageWithoutNavComponent_$ctor_1FEFDAB5(routeWithCurrentQueryParams(`${"/recommendations"}/gre/inspect`)((_arg_10) => KpiInspectComponent({
        navigationType: "getrelatedentities",
    })))))) : empty_1(), delay(() => append((access.RecommendationsKpiGceAccess ? true : isExperimentalFeaturesEnabled) ? append(singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsWithProps(singleton(new RouteProps(2, [true])))(`${"/recommendations"}/gce`)((_arg_11) => KpiOverviewComponent({
        navigationType: "getcomplementaryentities",
    })), navComponentWithCurrentQueryParams([t.t("Complementary"), dashboardIcon], [`${"/recommendations"}/gce`, permittedScopeAndDates]))), delay(() => singleton_1(PageWithoutNavComponent_$ctor_1FEFDAB5(routeWithCurrentQueryParams(`${"/recommendations"}/gce/inspect`)((_arg_12) => KpiInspectComponent({
        navigationType: "getcomplementaryentities",
    })))))) : empty_1(), delay(() => append((access.RecommendationsKpiGreceAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParams(`${"/recommendations"}/grece`)((_arg_13) => KpiOverviewComponent({
        navigationType: "getrecommendedentities",
    })), navComponentWithCurrentQueryParams([t.t("1:1 "), dashboardIcon], [`${"/recommendations"}/grece`, permittedScopeAndDates]))) : empty_1(), delay(() => ((access.RecommendationsKpiGbrAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParams(`${"/recommendations"}/gbr`)((_arg_14) => KpiOverviewComponent({
        navigationType: "getbasketrecommendations",
    })), navComponentWithCurrentQueryParams([t.t("Basket"), dashboardIcon], [`${"/recommendations"}/gbr`, permittedScopeAndDates]))) : empty_1())))))))));
    const recommendations = PageGroup_$ctor_Z104CF0BE("recommendations", t.t("Recommendations"), recommendationsKpiIcon, recommendationsViews);
    const merchandisingViews = toList(delay(() => append((access.RedirectsAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScope("/merchandising/redirects")((_arg_15) => ConfigurationRedirectsController()), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Redirects"), merchandisingRedirectsIcon], ["/merchandising/redirects", permittedParamsScopeOnly]))) : empty_1(), delay(() => append((access.ExperienceEditorAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScopeWithProps(singleton(new RouteProps(2, [true])))("/merchandising/experience")((_arg_16) => ConfigurationExperienceController()), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Experience Editor"), merchandisingExperienceIcon], ["/merchandising/experience", permittedParamsScopeOnly]))) : empty_1(), delay(() => append((access.ManualRecommendationsAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScopeWithProps(singleton(new RouteProps(2, [true])))("/merchandising/recommendations")((_arg_17) => ConfigurationRecommendationsController()), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Recommendations"), merchandisingRecommendationIcon], ["/merchandising/recommendations", permittedParamsScopeOnly]))) : empty_1(), delay(() => append((access.ExperienceEditorAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(PageWithoutNavComponent_$ctor_1FEFDAB5(routeWithCurrentQueryParamsAndNarrowedScope("/merchandising/experience/editor")((_arg_18) => ConfigurationExperienceRuleEditorController()))) : empty_1(), delay(() => ((access.PulseAccess ? true : isExperimentalFeaturesEnabled) ? singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParamsAndNarrowedScope("/merchandising/pulse")((_arg_19) => ConfigurationPulseController()), navComponentWithCurrentQueryParamsAndNarrowedScope([t.t("Pulse"), merchandisingPulseIcon], ["/merchandising/pulse", permittedParamsScopeOnly]))) : empty_1())))))))))));
    return ofArray([search, browse, recommendations, PageGroup_$ctor_Z104CF0BE("merchandising", t.t("Merchandising"), merchandisingIcon, merchandisingViews)]);
}

function createAdditionalViews(routeWithCurrentQueryParams, navComponentWithCurrentQueryParams) {
    return toList(delay(() => {
        if (DiagnosticsEnabled) {
            const diagnosticsIcon = FileProtectOutlined(empty(), empty());
            return singleton_1(Page_$ctor_36DAE502(routeWithCurrentQueryParams(empty(), singleton("/diagnostics"), (_arg) => DiagnosticsController(empty())), navComponentWithCurrentQueryParams(["Diagnostics", diagnosticsIcon], ["/diagnostics", permittedParamsScopeOnly])));
        }
        else {
            return empty_1();
        }
    }));
}

export class Props extends Record {
    constructor(getUser, pathName) {
        super();
        this.getUser = getUser;
        this.pathName = pathName;
    }
}

export function Props_$reflection() {
    return record_type("Loop54.Portal.WebUI.Views.Portal.Props", [], Props, () => [["getUser", lambda_type(unit_type, class_type("Fable.Core.JS.Promise`1", [User_$reflection()]))], ["pathName", string_type]]);
}

export const logo = ff_loop54_logo;

export const reactGaInterop = react_ga;

(function () {
    const arg_1 = {};
    reactGaInterop.initialize(GA_TRACKING_ID, arg_1);
})();

initialize();

Userpilot.initialize("NX-10a4dbf1");

export const antd_locale_en = en_US;

export const antd_locale_de = de_DE;

export const locales = locales_1;

i18next.use(initReactI18next);

i18next.init(new initI18next("en", false, locales));

const NotFound = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_8("/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/Views/Portal.fs") + "#L") + int32ToString(value_8(315))) + ";") + "Microsoft.FSharp.Collections.FSharpList`1[System.Tuple`2[System.String,System.Object]]", value_8("NotFound"), (_arg) => {
    const t = useTranslation();
    const children = [t.t("Oops, looks like this page does not exist. Go back to the "), Link(new NavProps(singleton(new Location(0, ["/"]))), singleton(t.t("start page.")))];
    return react.createElement(react.Fragment, {}, ...children);
}, undefined, undefined, "Of");

const Portal = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_8("/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/Views/Portal.fs") + "#L") + int32ToString(value_8(325))) + ";") + "Loop54.Portal.WebUI.Views.Portal.Props", value_8("Portal"), (props) => {
    let defaultOpenKeys, defaultSelectedKeys, children_1, children_18, children_17;
    const t = useTranslation();
    const siderCollapseState = useLocalStorage("isSiderCollapsed", false);
    const collapseSiderBtn = Button(ofArray([new ButtonProps(0, [(siderCollapseState[0]) ? (`${Portal_1.siderCollapseBtn} ${Portal_1.siderCollapseBtnCollapsed}`) : Portal_1.siderCollapseBtn]), new ButtonProps(3, [(siderCollapseState[0]) ? MenuUnfoldOutlined(empty(), empty()) : MenuFoldOutlined(empty(), empty())]), new ButtonProps(5, [(_arg) => {
        siderCollapseState[1]((state) => !state);
    }]), new ButtonProps(6, ["ghost"]), new ButtonProps(7, ["circle"])]), empty());
    const experimentalFeatures = useExperimentalFeatures(useExperimentalFeaturesEnabled());
    const expFeaturesCtxt = new ExperimentalFeaturesContext(experimentalFeatures.isExperimentalFeaturesEnabled[0], experimentalFeatures.isDebugInfoEnabled[0]);
    const history = useHistory();
    react.useEffect(() => {
        reactGaInterop.pageview(history.location.pathname + history.location.search);
    }, [history.location.pathname, history.location.search]);
    react.useEffect(() => {
        let arg;
        sendEvent(props.getUser, (arg = history.location.pathname, toText(printf("Viewed page: %s"))(arg)));
        Userpilot.reload();
    }, [history.location.pathname]);
    const experimentalFeatureSwitch = FeatureSwitch(new Props_1(switchLabel(t), "experimentalFeaturesSwitch", (value) => {
    }, experimentalFeatures.isExperimentalFeaturesEnabled));
    const debugInfoSwitch = FeatureSwitch(new Props_1(t.t("Debugging info"), "debuggingInfoSwitch", (value_1) => {
    }, experimentalFeatures.isDebugInfoEnabled));
    const notifications = react.useContext(Context);
    const withCurrentQueryParamsHook = useWithCurrentQueryParams();
    const navComponentWithCurrentQueryParams = curry3(withCurrentQueryParamsHook.navComponentWithCurrentQueryParams)((x) => x);
    const routeWithCurrentQueryParams = curry4(withCurrentQueryParamsHook.routeWithCurrentQueryParams)((x_1) => x_1);
    const querySelection = useQuerySelection(undefined);
    const userAccess = useUserAccess(undefined);
    const withNarrowedUrl = curry2(withCurrentQueryParamsHook.narrowScopeIfNeeded)(querySelection.findBestMatchForScope);
    const routeWithCurrentQueryParamsAndNarrowedScope = curry4(withCurrentQueryParamsHook.routeWithCurrentQueryParams)(withNarrowedUrl);
    const navComponentWithCurrentQueryParamsAndNarrowedScope = curry3(withCurrentQueryParamsHook.navComponentWithCurrentQueryParams)(withNarrowedUrl);
    let customerIdSelect;
    const customerIdOptions = map((tupledArg) => ({
        label: tupledArg[1],
        value: tupledArg[0],
    }), querySelection.customerOptions);
    customerIdSelect = Select(ofArray([new SelectProps(49, [CustomerValue_toText(querySelection.selectedCustomerId)]), new SelectProps(4, [QuerySelection.scopeSelect]), new SelectProps(26, [(customer) => {
        querySelection.setSelectedCustomer(customer);
    }]), new SelectProps(41, [t.t("Select a customer")]), new SelectProps(45, [true]), new SelectProps(38, ["label"]), new SelectProps(40, [customerIdOptions]), new SelectProps(11, [false])]), empty());
    let storefrontIdSelect;
    const storefrontIdOptions = map((tupledArg_1) => ({
        label: tupledArg_1[1],
        value: tupledArg_1[0],
    }), querySelection.storefrontOptions);
    storefrontIdSelect = Select(ofArray([new SelectProps(49, [ScopePartValueModule_toText(querySelection.selectedStorefrontId)]), new SelectProps(4, [QuerySelection.scopeSelect]), new SelectProps(26, [(storefrontId) => {
        querySelection.setSelectedStorefront(ScopePartValueModule_fromPart(storefrontId));
    }]), new SelectProps(41, [t.t("Select a storefront")]), new SelectProps(45, [true]), new SelectProps(38, ["label"]), new SelectProps(40, [storefrontIdOptions]), new SelectProps(11, [false])]), empty());
    let languageSelect;
    const languageOptions = map((value_4) => ({
        label: ScopePartValueModule_toText(value_4),
        value: ScopePartValueModule_toPart(value_4),
    }), querySelection.languageOptions);
    languageSelect = Select(ofArray([new SelectProps(49, [ScopePartValueModule_toText(querySelection.selectedLanguageCode)]), new SelectProps(4, [QuerySelection.scopeSelect]), new SelectProps(26, [(language) => {
        querySelection.setSelectedLanguage(ScopePartValueModule_fromPart(language));
    }]), new SelectProps(41, [t.t("Select a language")]), new SelectProps(45, [true]), new SelectProps(38, ["label"]), new SelectProps(40, [languageOptions]), new SelectProps(11, [false])]), empty());
    const siteCtxt = new QueryFilter(CustomerValue_toPart(querySelection.selectedCustomerId), ScopePartValueModule_toPart(querySelection.selectedStorefrontId), ScopePartValueModule_toPart(querySelection.selectedLanguageCode));
    let patternInput;
    let scopeDependentViews;
    if (userAccess == null) {
        scopeDependentViews = empty();
    }
    else {
        const access = userAccess;
        scopeDependentViews = createControlViews(experimentalFeatures.isExperimentalFeaturesEnabled[0], uncurry3(routeWithCurrentQueryParams), uncurry3(routeWithCurrentQueryParamsAndNarrowedScope), uncurry2(navComponentWithCurrentQueryParams), uncurry2(navComponentWithCurrentQueryParamsAndNarrowedScope), access, t);
    }
    const scopeIndependentViews = createAdditionalViews(uncurry3(routeWithCurrentQueryParams), uncurry2(navComponentWithCurrentQueryParams));
    const authDependentRoutes = toList(delay(() => {
        let children;
        return append(singleton_1((children = [Switch(empty(), toList(delay(() => append(collect((v) => v.Routes, scopeDependentViews), delay(() => singleton_1(Route(singleton(new RouteProps(0, ["*"])), singleton(NotFound(empty())))))))))], react.createElement(Context_1.Provider, {
            value: siteCtxt,
        }, ...children))), delay(() => collect((v_1) => v_1.Routes, scopeIndependentViews)));
    }));
    patternInput = [(userAccess == null) ? singleton(Route(empty(), singleton(Fallback))) : authDependentRoutes, (defaultOpenKeys = ((siderCollapseState[0]) ? [] : [t.t("search"), t.t("navigation"), t.t("recommendations"), t.t("configuration"), t.t("merchandising")]), (defaultSelectedKeys = [props.pathName], createRootNavComponent(append_1(scopeDependentViews, scopeIndependentViews), defaultOpenKeys, defaultSelectedKeys)))];
    const buttonSignOut = Button(ofArray([new ButtonProps(6, ["primary"]), new ButtonProps(7, ["round"]), new ButtonProps(8, ["large"]), new ButtonProps(5, [(_arg_3) => {
        history.push(signOutUri);
    }])]), singleton(t.t("Sign out")));
    const userProfile = react.useState(new Profile("", "", "", ""));
    react.useEffect(() => {
        const pr = props.getUser();
        pr.then((user) => {
            reactGaInterop.set({
                dimension1: user.profile.name,
                dimension2: user.profile.email,
            });
            userProfile[1](user.profile);
        });
    }, []);
    react.useEffect(() => {
        let matchValue_1;
        moment.updateLocale("en", momentEnLocaleConfig);
        moment.locale((userProfile[0]).language);
        t.i18n.changeLanguage((matchValue_1 = (userProfile[0]).language, (matchValue_1 === "de") ? (userProfile[0]).language : ((matchValue_1 === "en") ? (userProfile[0]).language : "en")));
    }, [(userProfile[0]).language]);
    react.useEffect(() => {
        let access_1, access_2, access_3, access_4, access_5, access_6, access_7;
        const matchValue_2 = history.location.pathname;
        let matchResult;
        switch (matchValue_2) {
            case "/configuration/boostBury": {
                if ((access_1 = userAccess, (!(((access_1 == null) ? true : value_8(access_1).BoostBuryAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "/configuration/synonyms": {
                if ((access_2 = userAccess, (!(((access_2 == null) ? true : value_8(access_2).SynonymsAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "/merchandising/redirects": {
                if ((access_3 = userAccess, (!(((access_3 == null) ? true : value_8(access_3).RedirectsAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "/merchandising/experience": {
                if ((access_4 = userAccess, (!(((access_4 == null) ? true : value_8(access_4).ExperienceEditorAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "/merchandising/experience/editor": {
                if ((access_5 = userAccess, (!(((access_5 == null) ? true : value_8(access_5).ExperienceEditorAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 4;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "/merchandising/recommendations": {
                if ((access_6 = userAccess, (!(((access_6 == null) ? true : value_8(access_6).ManualRecommendationsAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 5;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "/merchandising/pulse": {
                if ((access_7 = userAccess, (!(((access_7 == null) ? true : value_8(access_7).PulseAccess) ? true : expFeaturesCtxt.IsExperimentalFeaturesEnabled) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedStorefrontId)) ? true : !ScopePartValueModule_isConcrete(querySelection.selectedLanguageCode))) {
                    matchResult = 6;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            default:
                matchResult = 7;
        }
        switch (matchResult) {
            case 0: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 1: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 2: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 3: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 4: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 5: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 6: {
                notifications.Send("warning", "Not available", "The view is not available for the selected scope");
                break;
            }
            case 7: {
                break;
            }
        }
    }, [userAccess, querySelection.selectedStorefrontId, querySelection.selectedLanguageCode, history.location.pathname, experimentalFeatures.isExperimentalFeaturesEnabled[0]]);
    const topNavDropdown = Dropdown(ofArray([new DropdownProps(4, ["click"]), new DropdownProps(0, [true]), new DropdownProps(5, ["bottomRight"]), new DropdownProps(2, [Menu(empty(), singleton(ItemGroup(singleton(new ItemGroupProps(t.t("Account settings"))), ofArray([Item(empty(), singleton(experimentalFeatureSwitch)), Item(empty(), singleton(debugInfoSwitch))]))))])]), singleton((children_1 = [SettingFilled(empty(), empty()), DownOutlined(empty(), empty())], react.createElement("a", {}, ...children_1))));
    return Layout(singleton(new LayoutProps(1, [Portal_1.fullheight])), singleton((children_18 = [Header(singleton(new LayoutProps(1, [Portal_1.header])), toList(delay(() => {
        let props_5, children_3, props_3;
        return append(singleton_1((props_5 = [new HTMLAttr(64, [Portal_1.headerLogo])], (children_3 = [Link(new NavProps(singleton(new Location(0, [defaultPage]))), singleton((props_3 = [new HTMLAttr(64, [Portal_1.logo]), new HTMLAttr(149, [logo])], react.createElement("img", keyValueList(props_3, 1)))))], react.createElement("div", keyValueList(props_5, 1), ...children_3)))), delay(() => {
            let props_9, children_7;
            return append(singleton_1((props_9 = [new HTMLAttr(64, [Portal_1.headerSiteSelectWrapper])], (children_7 = [react.createElement("div", {
                id: "header-extra",
            }), customerIdSelect, storefrontIdSelect, languageSelect], react.createElement("div", keyValueList(props_9, 1), ...children_7)))), delay(() => {
                let props_13, children_11, children_9;
                return append(singleton_1((props_13 = [new HTMLAttr(64, [Portal_1.headerUserWrapper])], (children_11 = [TopNavGravatar(ofArray([new GravatarProps(0, [(userProfile[0]).email]), new GravatarProps(1, [30]), new GravatarProps(2, ["retro"])]), empty()), (children_9 = [(userProfile[0]).name], react.createElement("span", {}, ...children_9))], react.createElement("div", keyValueList(props_13, 1), ...children_11)))), delay(() => {
                    let props_15;
                    return append(experimentalFeatures.experimentalFeaturesAbility ? singleton_1((props_15 = [new HTMLAttr(64, [Portal_1.headerDropdownWrapper])], react.createElement("div", keyValueList(props_15, 1), topNavDropdown))) : empty_1(), delay(() => {
                        let props_17;
                        return singleton_1((props_17 = [new HTMLAttr(64, [Portal_1.headerSignoutWrapper])], react.createElement("div", keyValueList(props_17, 1), buttonSignOut)));
                    }));
                }));
            }));
        }));
    }))), Layout(empty(), singleton((children_17 = [collapseSiderBtn, Sider(ofArray([new SiderProps(4, [defaultOf()]), new SiderProps(0, [true]), new SiderProps(1, ["light"]), new SiderProps(2, [280]), new SiderProps(3, [siderCollapseState[0]])]), singleton(patternInput[1])), Content(empty(), singleton(wrapList(patternInput[0])))], react.createElement(Context_2.Provider, {
        value: expFeaturesCtxt,
    }, ...children_17))))], react.createElement(Context_3.Provider, {
        value: props.getUser,
    }, ...children_18))));
}, undefined, undefined, "Of");

export const Controller = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_8("/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/Views/Portal.fs") + "#L") + int32ToString(value_8(588))) + ";") + "Loop54.Portal.WebUI.Views.Portal.Props", value_8("Controller"), (props) => {
    let value, children;
    const antdLocale = react.useState(antd_locale_en);
    react.useEffect(() => {
        const pr = props.getUser();
        pr.then((user) => {
            boomerangRealUserMonitoring(user);
            window.BOOMR.addVar("ue", user.profile.email);
            let companyName;
            const matchValue = split(user.profile.email, ["@"], undefined, 0);
            companyName = ((!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 2)) ? item(1, matchValue) : "Invalid email");
            const arg_1 = {
                company: {
                    id: companyName,
                    name: companyName,
                },
            };
            Userpilot.identify(user.profile.id, arg_1);
        });
    }, []);
    react.useEffect(() => {
        const pr_1 = props.getUser();
        pr_1.then((user_1) => {
            let arg_2;
            const matchValue_1 = user_1.profile.language;
            switch (matchValue_1) {
                case "de": {
                    arg_2 = antd_locale_de;
                    break;
                }
                default:
                    arg_2 = antd_locale_en;
            }
            antdLocale[1](arg_2);
        });
    }, []);
    return ConfigProvider(singleton(new ConfigProviderProps(antdLocale[0])), singleton((value = useUserScopeInformation(props.getUser), (children = [Portal(props)], react.createElement(Context_4.Provider, {
        value: value,
    }, ...children)))));
}, undefined, undefined, "Of");

